import React from 'react';
import classNames from 'classnames';
import { Tooltip } from 'devextreme-react/tooltip';
import styles from './SummaryChartFilter.module.scss';
import moment from 'moment';
import PropTypes from 'prop-types';
import { TextLink } from '@otcmarketsgroup/otcm-ui';
import { Button } from '../../components/Button';
import { TextBox, DateBox } from 'devextreme-react';
import { datePattern } from '../../util/constants';

const calendarOptions = {
  maxZoomLevel: 'year'
};

const initialState = {
  date: new Date(),
  errorMessages: []
};

class SummaryChartFilter extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      ...initialState
    };

    // preserve the initial state in a new object
    this.baseState = this.state;
    this.getSummaryDataFilter = this.getSummaryDataFilter.bind(this);
    this.clearData = this.clearData.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.toggleMpidInfoTooltip = this.toggleMpidInfoTooltip.bind(this);
  }

  handleChange (event, name) {
    this.setState({
      [name]: event.value
    });
  }

  handleSubmit () {
    let queryParam = this.state;
    var errorMessages = [];
    if (!('date' in queryParam) || queryParam['date'] === null) {
      errorMessages.push('Please select Trade date');
    }
    this.setState({ errorMessages: errorMessages });
    if (errorMessages.length === 0) {
      this.getSummaryDataFilter(queryParam);
    }
  }

  getSummaryDataFilter (queryParam) {
    var params = [];

    Object.keys(queryParam).forEach((key) => {
      let val = queryParam[key];
      if (val !== null) {
        if (key === 'date' && moment.isDate(val)) {
          params[key] = moment(val).format(datePattern);
        } else if (typeof val === 'string') {
          if (val.trim() !== '') {
            params[key] = val;
          }
        } else {
          params[key] = val;
        }
      }
    });

    this.props.search(params);
  }

  clearData () {
    this.setState(this.baseState);
    this.props.clear();
  }

  renderErrorMessages () {
    const errorMessages = this.state.errorMessages;
    return errorMessages.map((errorMessage, i) => <div key={`Error-${i}`}>{errorMessage}</div>);
  }

  handleKeyDown (e) {
    if (e.key === 'Enter') {
      this.setState({
        isSymbolFocus: false,
        isMpidFocus: false
      });

      this.handleSubmit();
    };
  }

  toggleMpidInfoTooltip () {
    this.setState({
      mpidInfoTooltip: !this.state.mpidInfoTooltip
    });
  }

  render () {
    return (
      <div id='chartSummaryFilter'>
        <div className={styles.filterGridStyle} onKeyDown={this.handleKeyDown}>

          <div key={'dateKey'}><label>{'Trade Month'}</label><DateBox
            name={'date'}
            calendarOptions={calendarOptions}
            value={this.state['date']}
            placeholder={'MM/YYYY'}
            useMaskBehavior
            openOnFieldClick
            max={new Date()}
            onValueChanged={(e) => this.handleChange(e, 'date')}
            displayFormat={'MM/yyyy'} /></div>

          <div key={'mpidKey'}>
            <label><span>MPID</span>
              <span className={styles.mpidInfoIcon}>
                <i id={'mpidInfoIcon'} className={classNames('dx-icon-info')}
                  onMouseEnter={this.toggleMpidInfoTooltip}
                  onMouseLeave={this.toggleMpidInfoTooltip}
                />
              </span>
              <Tooltip
                target={'#mpidInfoIcon'}
                position='right'
                visible={this.state.mpidInfoTooltip}
                hideOnOutsideClick={false}
              > Specify Multiple MPID separated by comma</Tooltip>
            </label>
            <TextBox
              name={'mpid'} placeholder={'MPID'} value={this.state['mpid']} showClearButton
              valueChangeEvent='keyup'
              onValueChanged={(e) => this.handleChange(e, 'mpid')} />

          </div>

        </div>

        <div className={styles.formControls}>
          <div>
            <Button title='Graph' onClick={this.handleSubmit} size='extraSmall' />
            <TextLink className={styles.resetLink} size='small'
              text='Reset' onClick={this.clearData}
            />
          </div>
        </div>
        <div className={styles.errorMessages}>
          {this.state.errorMessages.length > 0 && this.renderErrorMessages()}
        </div>
      </div>
    );
  }
}
export default SummaryChartFilter;

SummaryChartFilter.propTypes = {
  clear: PropTypes.func,
  search: PropTypes.func
};
